export default __webpack_public_path__ + "static/media/DeviceMobile.841854e5.svg";